// Bonus Round System Module
class BonusManager {
    constructor() {
        this.bonusRound = {
            active: false,
            triggerSpawned: false, // Track if trigger is spawned but not collected
            triggerPowerup: null,
            boyPowerups: [],
            spawnTimer: null,
            endTimer: null,
            spawnsRemaining: 0,
            triggerCollected: false,
            bonusStartTime: null // Track when bonus round actually started
        };
        
        this.powerupSize = 25;
    }
    
    // Getter to expose bonus round state - only true when actually in bonus (after trigger collected)
    get inBonusRound() {
        const result = this.bonusRound.active && this.bonusRound.triggerCollected;
        return result;
    }
    
    // Getter to check if we're in bonus countdown (trigger spawned but not collected)
    get inBonusCountdown() {
        return this.bonusRound.active && this.bonusRound.triggerSpawned && !this.bonusRound.triggerCollected;
    }
    
    getMaleEmojisArray() {
        // Comprehensive collection of male emojis (not just faces)
        return [
            // Male faces and people
            '👦', // Boy
            '🧒', // Child
            '👶', // Baby
            '👨', // Man
            '🧑', // Person
            '👱‍♂️', // Blond man
            '👨‍🦱', // Curly hair man
            '👨‍🦳', // White hair man
            '👨‍🦲', // Bald man
            '🧔', // Bearded man
            '🧔‍♂️', // Bearded man
            '👨‍🦰', // Red hair man
            
            // Male professionals and roles
            '👨‍⚕️', // Male doctor
            '👨‍🌾', // Male farmer
            '👨‍🍳', // Male cook
            '👨‍🎓', // Male student
            '👨‍🎤', // Male singer
            '👨‍🏫', // Male teacher
            '👨‍🏭', // Male factory worker
            '👨‍💻', // Male technologist
            '👨‍💼', // Male office worker
            '👨‍🔧', // Male mechanic
            '👨‍🔬', // Male scientist
            '👨‍🎨', // Male artist
            '👨‍🚒', // Male firefighter
            '👨‍✈️', // Male pilot
            '👨‍🚀', // Male astronaut
            '👨‍⚖️', // Male judge
            
            // Male activities and sports
            '🏃‍♂️', // Male runner
            '🚶‍♂️', // Male walking
            '🏊‍♂️', // Male swimmer
            '🚴‍♂️', // Male cyclist
            '🏋️‍♂️', // Male weightlifter
            '🤾‍♂️', // Male handball player
            '🏌️‍♂️', // Male golfer
            '🧗‍♂️', // Male climber
            '🏄‍♂️', // Male surfer
            '🚣‍♂️', // Male rowing
            
            // Male fantasy and characters
            '🧙‍♂️', // Male wizard
            '🧚‍♂️', // Male fairy
            '🧛‍♂️', // Male vampire
            '🧜‍♂️', // Male merman
            '🧝‍♂️', // Male elf
            '🦸‍♂️', // Male superhero
            '🦹‍♂️', // Male supervillain
            '🤴', // Prince
            
            // Male gestures and poses
            '🙋‍♂️', // Male raising hand
            '🙅‍♂️', // Male gesturing no
            '🙆‍♂️', // Male gesturing OK
            '💁‍♂️', // Male tipping hand
            '🙇‍♂️', // Male bowing
            '🤦‍♂️', // Male facepalming
            '🤷‍♂️', // Male shrugging
            '🙍‍♂️', // Male pouting
            '🙎‍♂️', // Male frowning
            '💆‍♂️', // Male getting massage
            '💇‍♂️', // Male getting haircut
            '🕴️', // Male in business suit levitating
        ];
    }
    
    getBoyEmoji() {
        const maleEmojis = this.getMaleEmojisArray();
        return maleEmojis[Math.floor(Math.random() * maleEmojis.length)];
    }
    
    getTriggerBoyEmoji() {
        // Always return the first emoji from the shared maleEmojis array for consistency
        const maleEmojis = this.getMaleEmojisArray();
        return maleEmojis[0]; // Always return the first emoji (👦)
    }
    
    startBonusRound(gameRunning, spawnTriggerCallback) {
        if (!gameRunning || this.bonusRound.active) return;
        
        console.log('🎉 BONUS TRIGGER SPAWNING!');
        this.bonusRound.active = true;
        this.bonusRound.triggerSpawned = false;
        this.bonusRound.triggerCollected = false;
        this.bonusRound.spawnsRemaining = 0;
        
        // Clear existing timers
        if (this.bonusRound.spawnTimer) clearInterval(this.bonusRound.spawnTimer);
        if (this.bonusRound.endTimer) clearTimeout(this.bonusRound.endTimer);
        
        // Spawn the trigger boy powerup
        spawnTriggerCallback();
        this.bonusRound.triggerSpawned = true;
        
        // Set 5-second timer for the trigger powerup
        this.bonusRound.endTimer = setTimeout(() => {
            if (!this.bonusRound.triggerCollected) {
                console.log('⏰ Bonus trigger timed out - ending bonus round');
                this.endBonusRound(); // No audioManager needed since bonus music never started
            }
        }, 5000);
    }
    
    spawnBonusTrigger(powerupsArray, audioManager) {
        const screenWidth = window.innerWidth;
        const maxY = window.innerHeight - 140;
        
        const boyEmoji = this.getTriggerBoyEmoji(); // Use specific trigger emoji
        const triggerPowerup = {
            id: Date.now() + Math.random(),
            x: Math.random() * (screenWidth - this.powerupSize),
            y: Math.random() * (maxY - this.powerupSize - 80) + 80,
            size: this.powerupSize,
            emoji: boyEmoji, // Add emoji property for canvas rendering
            element: null,
            collected: false,
            type: 'bonus-trigger',
            spawnTime: Date.now(),
            // Movement properties - faster movement for trigger
            vx: (Math.random() - 0.5) * 8, // Random horizontal velocity (-4 to +4)
            vy: (Math.random() - 0.5) * 8, // Random vertical velocity (-4 to +4)
            speed: 4
        };
        
        // No DOM element needed - will render on canvas with special effects
        triggerPowerup.element = null;
        this.bonusRound.triggerPowerup = triggerPowerup;
        powerupsArray.push(triggerPowerup);
    }
    
    spawnBoyPowerup(powerupsArray) {
        const screenWidth = window.innerWidth;
        const maxY = window.innerHeight - 140;
        
        const boyEmoji = this.getBoyEmoji();
        const boyPowerup = {
            id: Date.now() + Math.random(),
            x: Math.random() * (screenWidth - this.powerupSize),
            y: Math.random() * (maxY - this.powerupSize - 80) + 80,
            size: this.powerupSize,
            emoji: boyEmoji, // Add emoji property for canvas rendering
            element: null,
            collected: false,
            type: 'bonus-boy',
            spawnTime: Date.now(),
            lifetime: 15000 // 15 seconds lifetime - enough time to collect all boys
        };
        
        // No DOM element needed - will render on canvas with animation
        boyPowerup.element = null;
        boyPowerup.animationOffset = Math.random() * Math.PI * 2; // Random animation phase
        
        // Add movement properties to bonus boys
        boyPowerup.vx = (Math.random() - 0.5) * 3; // Random horizontal velocity (-1.5 to +1.5)
        boyPowerup.vy = (Math.random() - 0.5) * 3; // Random vertical velocity (-1.5 to +1.5)
        boyPowerup.speed = 1.5;
        this.bonusRound.boyPowerups.push(boyPowerup);
        powerupsArray.push(boyPowerup);
    }
    
    startBoyPowerupSpawning(gameRunning, audioManager, powerupsArray) {
        this.bonusRound.spawnsRemaining = 10;
        console.log('🎊 Bonus trigger collected! Spawning 10 boy powerups!');
        
        // Store reference to powerups array for spawning
        this.powerupsArrayRef = powerupsArray;
        
        // Now switch to bonus music since trigger was collected
        audioManager.switchToBonusMusic();
        
        // Spawn boy powerups every 1 second
        this.bonusRound.spawnTimer = setInterval(() => {
            if (this.bonusRound.spawnsRemaining > 0) {
                this.spawnBoyPowerup(this.powerupsArrayRef);
                this.bonusRound.spawnsRemaining--;
                if (this.bonusRound.spawnsRemaining <= 0) {
                    clearInterval(this.bonusRound.spawnTimer);
                    // The bonus round will end automatically when all boys are collected/expired
                    // This is now handled in the update() method
                }
            } else {
                clearInterval(this.bonusRound.spawnTimer);
            }
        }, 1000);
    }
    
    endBonusRound(audioManager, removePowerupCallback) {
        if (!this.bonusRound.active) {
            console.log('⚠️ endBonusRound called but bonus round not active');
            return;
        }
        
        console.log('🎉 BONUS ROUND ENDING - State before cleanup:', {
            active: this.bonusRound.active,
            triggerCollected: this.bonusRound.triggerCollected,
            triggerSpawned: this.bonusRound.triggerSpawned,
            spawnsRemaining: this.bonusRound.spawnsRemaining,
            boyPowerupsCount: this.bonusRound.boyPowerups.length
        });
        
        // Store the trigger collected state before resetting
        const wasTriggered = this.bonusRound.triggerCollected;
        
        this.bonusRound.active = false;
        this.bonusRound.triggerSpawned = false;
        this.bonusRound.triggerCollected = false;
        this.bonusRound.bonusStartTime = null;
        
        // Clear timers
        if (this.bonusRound.spawnTimer) clearInterval(this.bonusRound.spawnTimer);
        if (this.bonusRound.endTimer) clearTimeout(this.bonusRound.endTimer);
        
        // Only switch back to original music if trigger was collected (music was changed)
        if (wasTriggered && audioManager) {
            audioManager.switchToOriginalMusic();
        }
        
        // Remove any remaining bonus powerups
        if (this.bonusRound.triggerPowerup && !this.bonusRound.triggerPowerup.collected && removePowerupCallback) {
            removePowerupCallback(this.bonusRound.triggerPowerup);
        }
        
        // Clean up boy powerups array
        this.bonusRound.boyPowerups = [];
        this.bonusRound.triggerPowerup = null;
    }
    
    updateBonusTriggerMovement(powerup) {
        if (powerup.type !== 'bonus-trigger' || powerup.vx === undefined) return;
        
        // Update position
        powerup.x += powerup.vx;
        powerup.y += powerup.vy;
        
        // Bounce off screen edges
        const maxX = window.innerWidth - powerup.size;
        const maxY = window.innerHeight - 140 - powerup.size;
        
        if (powerup.x <= 0 || powerup.x >= maxX) {
            powerup.vx *= -1; // Reverse horizontal direction
            powerup.x = Math.max(0, Math.min(maxX, powerup.x)); // Keep in bounds
        }
        
        if (powerup.y <= 80 || powerup.y >= maxY) {
            powerup.vy *= -1; // Reverse vertical direction
            powerup.y = Math.max(80, Math.min(maxY, powerup.y)); // Keep in bounds
        }
        
        // Position updated - no DOM element to update
    }
    
    updateBonusBoyMovement(powerup) {
        if (powerup.type !== 'bonus-boy' || powerup.vx === undefined) return;
        
        // Update position
        powerup.x += powerup.vx;
        powerup.y += powerup.vy;
        
        // Bounce off screen edges
        const maxX = window.innerWidth - powerup.size;
        const maxY = window.innerHeight - 140 - powerup.size;
        
        if (powerup.x <= 0 || powerup.x >= maxX) {
            powerup.vx *= -1; // Reverse horizontal direction
            powerup.x = Math.max(0, Math.min(maxX, powerup.x)); // Keep in bounds
        }
        
        if (powerup.y <= 80 || powerup.y >= maxY) {
            powerup.vy *= -1; // Reverse vertical direction
            powerup.y = Math.max(80, Math.min(maxY, powerup.y)); // Keep in bounds
        }
        
        // Position updated - no DOM element to update
    }
    
    collectBonusTrigger(audioManager, powerupsArray) {
        // Ensure the bonus round is active when trigger is collected
        this.bonusRound.active = true;
        this.bonusRound.triggerCollected = true;
        this.bonusRound.bonusStartTime = Date.now(); // Track when bonus round actually started
        clearTimeout(this.bonusRound.endTimer); // Cancel the 5-second timeout
        
        this.startBoyPowerupSpawning(true, audioManager, powerupsArray);
        return 50; // Points for collecting trigger
    }
    
    collectBonusBoy(powerup) {
        // Remove from bonus round tracking
        const boyIndex = this.bonusRound.boyPowerups.indexOf(powerup);
        if (boyIndex > -1) {
            this.bonusRound.boyPowerups.splice(boyIndex, 1);
        }
        return 50; // Points for collecting boy
    }
    
    update(game, now) {
        // Check if bonus round should end when all boys are gone
        if (this.bonusRound.active && this.bonusRound.triggerCollected && this.bonusRound.spawnsRemaining <= 0) {
            // Use our own tracking array instead of the main powerups array
            const remainingBoys = this.bonusRound.boyPowerups.length;
            
            // Also check for expired boys in the main array and clean them up
            if (this.powerupsArrayRef) {
                for (let i = this.powerupsArrayRef.length - 1; i >= 0; i--) {
                    const powerup = this.powerupsArrayRef[i];
                    if (powerup.type === 'bonus-boy') {
                        // Check if this boy has expired or been collected
                        const boyStillTracked = this.bonusRound.boyPowerups.some(b => b.id === powerup.id);
                        if (!boyStillTracked) {
                            // This boy was collected or expired, remove it from main array
                            this.powerupsArrayRef.splice(i, 1);
                        }
                    }
                }
            }
            
            console.log(`🔍 Bonus round end check: remainingBoys=${remainingBoys}, spawnsRemaining=${this.bonusRound.spawnsRemaining}`);
            
            if (remainingBoys === 0) {
                console.log('🎊 All bonus boys gone! Ending bonus round...');
                this.endBonusRound(game.audioManager);
            }
        }
        
        // Also check for timeout - if bonus round has been active too long, force end it
        if (this.bonusRound.active && this.bonusRound.triggerCollected) {
            const bonusStartTime = this.bonusRound.bonusStartTime;
            if (bonusStartTime && (now - bonusStartTime) > 30000) { // 30 second max bonus round
                console.log('⏰ Bonus round timed out after 30 seconds, force ending...');
                this.endBonusRound(game.audioManager);
            }
        }
    }
    
    reset() {
        // Reset bonus round state
        this.bonusRound.active = false;
        this.bonusRound.triggerSpawned = false;
        this.bonusRound.triggerPowerup = null;
        this.bonusRound.boyPowerups = [];
        this.bonusRound.spawnsRemaining = 0;
        this.bonusRound.triggerCollected = false;
        this.bonusRound.bonusStartTime = null;
        
        // Clear any timers
        if (this.bonusRound.spawnTimer) {
            clearTimeout(this.bonusRound.spawnTimer);
            this.bonusRound.spawnTimer = null;
        }
        if (this.bonusRound.endTimer) {
            clearTimeout(this.bonusRound.endTimer);
            this.bonusRound.endTimer = null;
        }
    }
    
    render(ctx) {
        // Placeholder render method - bonus elements are rendered elsewhere
        // This method exists to prevent errors but doesn't need to do anything
        // as bonus elements are handled in the main render loop
    }
}

// ES6 export for Vite
export default BonusManager;